import { MacroNutrients } from '../@types/generated/graphql/catalog-service/graphql';

// @todo imo the API should just return this where applicable ; until then, have central place for labelling
export const NUTRITION_CATEGORY_CONFIG: Record<
  keyof Omit<MacroNutrients, '__typename' | 'caloriesInG'>,
  { displayName: string; sortOrder: number }
> = {
  servingSizeInOz: { displayName: 'Serving Size', sortOrder: 0 },
  calories: { displayName: 'Calories', sortOrder: 1 },
  totalFatInG: { displayName: 'Total Fat', sortOrder: 2 },
  saturatedFatInG: { displayName: 'Saturated Fat', sortOrder: 3 },
  cholesterolInMg: { displayName: 'Cholesterol', sortOrder: 4 },
  sodiumInMg: { displayName: 'Sodium', sortOrder: 5 },
  totalCarbsInG: { displayName: 'Total Carbs', sortOrder: 6 },
  dietaryFiberInG: { displayName: 'Dietary Fiber', sortOrder: 7 },
  netCarbsInG: { displayName: 'Net Carbs', sortOrder: 8 },
  sugarsInG: { displayName: 'Sugars', sortOrder: 9 },
  addedSugarInG: { displayName: 'Added Sugar', sortOrder: 10 },
  proteinInG: { displayName: 'Protein', sortOrder: 11 },
  vitaminDInMcg: { displayName: 'Vitamin D', sortOrder: 12 },
  calciumInMg: { displayName: 'Calcium', sortOrder: 13 },
  ironInMg: { displayName: 'Iron', sortOrder: 14 },
  potassiumInMg: { displayName: 'Potassium', sortOrder: 15 },
};

// Stripe stuff
export type StripeInvoiceInformation = {
  invoiceNumber: string;
  email: string;
  paymentAmountInCents: number;
  firstDeliveryWeek?: string;
  name: string;
  firstDelivery: { deliveryDate: string; estimatedDeliveryDate: string };
};
